import { render } from "./DictData.vue?vue&type=template&id=6b58b974&scoped=true"
import script from "./DictData.vue?vue&type=script&lang=js"
export * from "./DictData.vue?vue&type=script&lang=js"

import "./DictData.vue?vue&type=style&index=0&id=6b58b974&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b58b974"]])

export default __exports__